import { LeftBarItem } from "components/Sidebar/LeftBar";
import { Settings } from "components/icons/Navbar/Settings";
import { Billing } from "components/icons/Navbar/Billing";
import { Team } from "components/icons/Navbar/Team";
import { Ticket } from "components/icons/LeftNav/Ticket";
import { GridFour } from "components/icons/GridFour";
import { IntegrationIcon } from "components/icons/LeftNav/IntegrationIcon";
import { ListIcon } from "components/icons/ListIcon";
import { SmallBellIcon } from "components/icons/LeftNav/SmallBellIcon";
import { useRoleBasedView } from "hooks/useRoleBasedView";
import { parse, stringify } from "qs";
import { useLocation } from "react-router-dom";
import ClaudeIconImg from "static/images/ClaudeIcon.svg";

const ClaudeMenuIcon = () => (
  <img src={ClaudeIconImg} alt="Claude" className="t-h-4 t-w-4" />
);

export const SettingsNav = () => {
  const { isCustomer, isAdmin } = useRoleBasedView();
  const { search } = useLocation();

  const parsedSearch = parse(search, { ignoreQueryPrefix: true });
  const searchQuery = stringify(
    {
      entity: parsedSearch.entity,
      company: parsedSearch.company,
    },
    { skipNulls: true, addQueryPrefix: true }
  );

  return (
    <div className="t-h-full">
      {isCustomer && (
        <LeftBarItem to={`/services${searchQuery}`} icon={GridFour}>
          Products & Services
        </LeftBarItem>
      )}
      {isCustomer && (
        <LeftBarItem to={`/billing${searchQuery}`} icon={Billing}>
          Billing
        </LeftBarItem>
      )}

      <LeftBarItem exact to={`/profile${searchQuery}`} icon={Settings}>
        Profile
      </LeftBarItem>

      {isCustomer && (
        <>
          <LeftBarItem to={`/team${searchQuery}`} icon={Team}>
            Team
          </LeftBarItem>
          <LeftBarItem
            exact
            to={`/claude-integration${searchQuery}`}
            icon={ClaudeMenuIcon}
          >
            Connect to Claude
          </LeftBarItem>
          <LeftBarItem
            to={`/api-settings${searchQuery}`}
            icon={IntegrationIcon}
          >
            API access
          </LeftBarItem>
        </>
      )}

      {isAdmin && (
        <LeftBarItem
          exact
          to={`/notifications${searchQuery}`}
          icon={SmallBellIcon}
        >
          Notifications
        </LeftBarItem>
      )}

      {isCustomer && (
        <>
          <LeftBarItem to={`/auditlog${searchQuery}`} icon={ListIcon}>
            Audit log
          </LeftBarItem>
          <LeftBarItem to={`/tickets${searchQuery}`} icon={Ticket}>
            Support tickets
          </LeftBarItem>
        </>
      )}
    </div>
  );
};
